import { createAsyncTypes } from 'utils/ActionCreator'

export const FETCH_INCIDENTS_COUNT_ASYNC = createAsyncTypes(
  'FETCH_INCIDENTS_COUNT_ASYNC',
  'Dashboard/Home/ResolutionCenter'
)
